var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagKorean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "-72 -48 144 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-72-48v96H72v-96z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-56.30993247402)",
    d: "M12-50h-24m24 6h-24m24 6h-24m11 76h-11m24 0H1m-2 6h-11m24 0H1m-2 6h-11m24 0H1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-123.69006752598)",
    d: "M-12-50h24m-24 6h11m2 0h11m-24 6h24m-24 76h11m2 0h11m-24 6h24m-24 6h11m2 0h11"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-56.30993247402)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cd2e3a",
    d: "M0 12a18 18 0 110-36 24 24 0 110 48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047a0",
    d: "M0-24a24 24 0 100 48 12 12 0 100-24 12 12 0 110-24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagKorean);
export default __webpack_public_path__ + "static/media/flag_korean.b705552686687c935d994819b7f41d4f.svg";
export { ForwardRef as ReactComponent };